import React, { useState } from "react";
import * as firebase from 'firebase/app';
import { withRouter } from 'react-router-dom';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import logo from '../HomeNav/AULogoSmall.png';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
  return <MuiAlert elevation={10} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      border: '0',
      borderColor: 'white',
      borderRadius: '0'
    },
  },

  textField: {
    margin: '0px 0px 1.5rem 0px',
    display: 'block',
    textAlign: 'center'
  },

}));

const LoginInput = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'green',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'green',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'lightslategray',
        borderRadius: '0',
        borderWidth: '1.2px'
      },
      '&:hover fieldset': {
        borderColor: 'green',
        borderWidth: '2px'
      },
      '&.Mui-focused fieldset': {
        borderColor: 'green',
        borderWidth: '2px'
      },
    },
  },

})(TextField);

const ResetPassword = (props) => {
  const [email, setEmail] = useState("");
  const [error, setErrors] = useState("");
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [successSnackBar, setSuccessSnackBar] = useState(false);
  const [emailSent, setEmailSent] = useState(false);


  const loginStyleClasses = useStyles();

  const handleForm = e => {

    e.preventDefault();

    firebase.auth().sendPasswordResetEmail(email)
    .then(function() {
        // Email sent.
        setEmailSent(true);
        setSuccessSnackBar(true);
      })
    .catch(e => {
      setErrors(e.message);
      setErrorSnackbar(true);
    });
  };

  return (

      <form onSubmit={e => handleForm(e)} className="loginFormControl">

        <div style={{textAlign: 'center', marginTop:'1.5rem'}}>
          <img src={logo} alt="Athletes Untapped" className="AULogoLogin"/>
          <p className="loginText" style={{fontSize: 'x-large'}}>Reset Your Password</p>
          <hr style={{width: '35%', border: '1px solid lightslategray', marginBottom: '1.5rem'}}/>
        </div>
        {!emailSent ? 
        <LoginInput
          className={loginStyleClasses.textField}
          value={email}
          onChange={e => setEmail(e.target.value)}
          name="email"
          type="email"
          placeholder="Email"
          variant="outlined"
          inputProps={{style: {boxShadow: 'none', fontFamily: 'Lucida Sans, Lucida Sans Regular, Lucida Grande, Lucida Sans Unicode, Geneva, Verdana, sans-serif'}}}
        />:null}
        {emailSent ? 
        <div className="resetSuccess">
            <p >A password reset link was sent to your email {email}.</p>
        </div>
        :null}
        {!emailSent ? 
        <div className="loginButton">
          <button type="submit" style={{minWidth: '9rem'}}>Send Reset Link</button>
        </div>:null}
        <Snackbar open={errorSnackbar}  onClose={e => setErrorSnackbar(false)}>
          <Alert onClose={e => setErrorSnackbar(false)} severity="error">
              {error}
          </Alert>
        </Snackbar>
        <Snackbar open={successSnackBar}  onClose={e => setSuccessSnackBar(false)}>
          <Alert onClose={e => setSuccessSnackBar(false)} severity="success">
              Password reset email successfully sent!
          </Alert>
        </Snackbar>
      </form>
  );
};

export default withRouter(ResetPassword);
